module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('bloco', {
    staticClass: "-padding-desktop",
    attrs: {
      "id": "localizacao"
    }
  }, [_c('header', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('titulo', {
    staticClass: "-withbar -upper"
  }, [_vm._v("Localização")])], 1), _c('div', {
    staticClass: "conteudo",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('p', [_vm._v("Centro da Reitoria"), _c('br'), _vm._v("Campus Universitário Lagoa Nova, CEP 59078-970 | Natal/RN - Brasil")]), _c('div', {
    staticClass: "mapa"
  }, [_c('iframe', {
    attrs: {
      "src": _vm.url,
      "frameborder": "0",
      "allowfullscreen": "allowfullscreen"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f81f949a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/modules/Localizacao.vue
// module id = 526
// module chunks = 0